export const LABELS = {
	CSV_EXPORT_BUTTON: 'Download CSV',
	CSV_EXPORT_ERROR: 'Failed to load CSV export data'
};
